const config = {
    base_url: process.env.REACT_APP_API_BASE_URL,
    check_in_url: process.env.REACT_APP_CHECK_IN_URL
};

export default config;
